(() => {
  const FILE_PREVIEW_CONTAINER_SELECTOR = '.file-preview'
  const FILE_LIST_CONTAINER_SELECTOR = '.file-list'

  bindEvents()

  function bindEvents() {
    $('.has-upload').on('change', '[type="file"]', handleInputFileChange)
  }

  function handleInputFileChange({target}) {
    const files = this.files;
    let filePreviewContainer = target.parentElement.querySelector(FILE_PREVIEW_CONTAINER_SELECTOR)
    let fileListContainer = target.parentElement.querySelector(FILE_LIST_CONTAINER_SELECTOR)
    let imageType = /image.*/;

    for (let file of files) {
      if(file.type.match(imageType)) {
        createPreview(file, filePreviewContainer)
      } else {
        createList(file,fileListContainer )
      }
    }
  }

  function createList(file, fileListContainer) {
    let filesize = formatFileSize(file.size)
    fileListContainer.innerHTML+=`<p class="file-name">${file.name}</p>
                                     <p class="file-size">${filesize}</p>`
  }

  function createPreview(file, filePreviewContainer) {
    let reader = new FileReader()
    let image = new Image()
    filePreviewContainer.innerHTML = ''

    reader.addEventListener("load", function() {
      image.height = 100
      image.title = file.name
      image.src = this.result
      image.classList.add('img-thumb')
      filePreviewContainer.appendChild(image)
    }, false)

    reader.readAsDataURL(file)
  }

  function formatFileSize(size, unit = 0) {
    const units = ['B', 'KB', 'MB', 'GB'];

    return size > 1024 ? formatFileSize(size / 1024, unit+1) : `${size.toFixed(2)} ${units[unit]}`
  }
})()
